import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createHelpCenterAccountApi } from './index';
import { createFakeGetResponder, createFakePostResponder } from '../../../test-utils';
export var createHelpCenterAccountApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createHelpCenterAccountApi('', fakeHttp);
    var accountRelativePath = '/account';
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenIsHelpcenterEnabled: function (dto) {
            var url = accountRelativePath + "/helpCenter?id=" + dto.id;
            return createFakeGetResponder(fakeHttp, url);
        },
        whenEnableHelpCenter: function (dto) {
            var url = accountRelativePath + "/helpCenter/enable";
            return createFakePostResponder(fakeHttp, url)(dto);
        },
        whenDisableHelpCenter: function (dto) {
            var url = accountRelativePath + "/helpCenter/disable";
            return createFakePostResponder(fakeHttp, url)(dto);
        },
        whenIsTicketingEnabled: function (dto) {
            var url = accountRelativePath + "/helpCenterTicketsPage?id=" + dto.brandId;
            return createFakeGetResponder(fakeHttp, url);
        },
        whenEnableTicketing: function (dto) {
            var url = accountRelativePath + "/helpCenterTicketsPage/enable";
            return createFakePostResponder(fakeHttp, url)(dto);
        },
        whenDisableTicketing: function (dto) {
            var url = accountRelativePath + "/helpCenterTicketsPage/disable";
            return createFakePostResponder(fakeHttp, url)(dto);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map